import { Group } from "@radix-ui/react-dropdown-menu";
import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DropdownMenuGroupProps } from "../types";

function DropdownMenuGroup({ className, ...props }: DropdownMenuGroupProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Group
      data-slot="dropdown-menu-group"
      className={cn(className, classes)}
      {...native}
    />
  );
}

DropdownMenuGroup.displayName = "DropdownMenu.Group";

export default DropdownMenuGroup;
